import { useAppSelector } from 'hooks'
import { TargetFilterInterface } from 'components/targetList/targetTypes'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { constants } from 'helpers'
import { FootCircleIcon, HandShakeIcon } from 'assets'
import { colors } from 'styles/colors'
import { handleTargetFilter } from 'actions/targetListAction'

const { TARGET_LIST_FILTERS } = constants

export const TargetFilter: React.FC<TargetFilterInterface> = ({
    filterHandler,
    veCode
}) => {
    const { t } = useTranslation()
    const {
        selectedFilter,
        targetList = [],
        processedTargetList = [],
        processing
    } = useAppSelector((state) => state.targetList[veCode] || {})

    const targetListFilters = useMemo(() => {
        const validTargetList = Array.isArray(targetList) ? targetList : []

        return [
            {
                name: t('targetFilterOption.notVisited'),
                id: TARGET_LIST_FILTERS.NOT_VISITED,
                icon: FootCircleIcon,
                count: handleTargetFilter(
                    TARGET_LIST_FILTERS.NOT_VISITED,
                    validTargetList
                ).length
            },
            {
                name: t('targetFilterOption.visited'),
                id: TARGET_LIST_FILTERS.VISITED,
                icon: HandShakeIcon,
                count: handleTargetFilter(
                    TARGET_LIST_FILTERS.VISITED,
                    validTargetList
                ).length
            }
        ]
    }, [targetList, processedTargetList, t])

    const filterClickHandler = (selectedFilterVal: string) => {
        if (selectedFilter === selectedFilterVal) {
            return filterHandler(TARGET_LIST_FILTERS.ALL, veCode)
        }

        filterHandler(selectedFilterVal, veCode)
    }

    return (
        <div className="target--filter-parent">
            {targetListFilters.map((targetFilter) => {
                const selected = selectedFilter === targetFilter.id
                const color =
                    selected &&
                    targetFilter.id === TARGET_LIST_FILTERS.NOT_VISITED
                        ? colors.maroon
                        : selected
                        ? colors.primary
                        : ''

                return (
                    <button
                        className="target--filter-button"
                        key={`${targetFilter.id}-${targetFilter.count}`}
                        onClick={() => filterClickHandler(targetFilter.id)}
                        aria-label={`target list filter ${targetFilter.id}`}
                        disabled={processing}
                    >
                        {<targetFilter.icon color={color} />}
                        {!processing && (
                            <span
                                className={
                                    'target--filter-dot' +
                                    (selected ? '--selected' : '')
                                }
                                aria-label={`target filter count ${targetFilter.id}`}
                            >
                                {targetFilter.count}
                            </span>
                        )}
                    </button>
                )
            })}
        </div>
    )
}
